import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from "react-i18next";
import * as AdaptiveCards from "adaptivecards";
import { dialog, app } from "@microsoft/teams-js";
import moment from 'moment';
import { markDownToHtml } from '../../helpers/formattingHelper'
import FileUploader from './FileUploader/fileUploader'
import CheckBoxWithTooltip from './CheckBoxWithTooltip/checkBoxWithTooltip'
import './newMessage.scss';
import './teamTheme.scss';
import {
    getDraftNotification, getTeams, createDraftNotification,
    updateDraftNotification, searchUsers, searchGroups, getGroups, getUsers,
    verifyGroupAccess, deleteUsersAudience, getSentNotification,
    updateScheduledNotification, cancelScheduledMessage, getAllTemplates, getAllUserTemplates
} from '../../apis/messageListApi';
import {
    getInitAdaptiveCard,
    setCard,
    setActions, 
    setCardStyle, 
    enableMultiSpaces
} from '../AdaptiveCard/adaptiveCard';
import { getBaseUrl } from '../../configVariables';
import MyEditor from '../RichEditor/richEditor'
import { TFunction } from "i18next";
import { ITemplate } from '../../templateModel'
import {
    getInitIncidentAdaptiveCard, setAreaInvolved, setSeverity, setNetworkAffected,
    setAgencyAffected, setServiceImpact, setIssueStartTime, setIncidentCardTitle,
    setLatestUpdate, setActionsIncident
} from '../AdaptiveCard/incidentAdaptiveCard';
import { Button, Spinner, RadioGroup, Radio, Input, Tooltip, Text, Checkbox, Option, Textarea, Dropdown, Link, Field, InputOnChangeData, RadioGroupOnChangeData } from "@fluentui/react-components"
import { Info24Regular, Attach20Regular, Delete24Regular, Dismiss24Regular } from '@fluentui/react-icons';
import Multiselect from './Multiselect/multiselect';
import { ReactComponent as ExcelIcon } from '../../assets/Excel.svg';
import { debounce } from '../../utility/debounceUtility';
import NewsTemplate, { INewsletter, INewsSection } from './newsTemplate';
import LinkSet, { checkUrlError, IAction } from './LinkSet/linkSet';
import ICardVideo from './ICardVideo';

export interface IOption {
    id: string,
    name: string,
    mail?: string
}

export interface IDraftMessage {
    id?: string,
    title: string,
    imageLink?: string,
    videoLink?: string,
    videoImageLink?: string,
    summary?: string,
    summary2?: string,
    author: string,
    actions: IAction[],
    buttonTitle?: string,
    buttonLink?: string,
    eventUrl?: string,
    teams: string[],
    rosters: string[],
    groups: string[],
    users: string[],
    usersListFile?: string,
    allUsers: boolean,
    scheduledDate?: Date,
    isScheduled: boolean,
    updateType?: string,
    isImportant: boolean,
    incidentCardTitle: string,
    incidentSeverity: string,
    areasInvolved: string[],
    networkAffected: string,
    agencyAffected: string,
    serviceImpact: string,
    latestUpdate: string,
    latestUpdateDate?: Date,
    issueStartTime?: Date,
    sendAsEmail?: boolean,
    emailOffset?: string,
    newsletterHeader?: string,

    titles?: { [key: string]: string },
    summaries?: { [key: string]: string },
    secondarySummaries?: { [key: string]: string },
    imageLinks?: { [key: string]: string },
    videoLinks?: { [key: string]: ICardVideo },
    authors?: { [key: string]: string },
    actionsBlocks?: { [key: string]: IAction[] },
}

export interface formState {

    titles?: { [key: string]: string },
    summaries?: { [key: string]: string },
    secondarySummaries?: { [key: string]: string },
    imageLinks?: { [key: string]: string },
    videoLinks?: { [key: string]: ICardVideo },
    authors?: { [key: string]: string },
    actionsBlocks?: { [key: string]: IAction[] },

    title: string,
    summary?: string,
    summary2?: string,
    imageLink?: string,
    videoLink?: string,
    videoImageLink?: string,
    author: string,
    card?: any,
    page: string,
    teamsOptionSelected: boolean,
    rostersOptionSelected: boolean,
    allUsersOptionSelected: boolean,
    groupsOptionSelected: boolean,
    usersOptionSelected: boolean,
    emailOptionsSelected: boolean,
    emailOffsetValue: number,
    teams?: IOption[],
    isAllUserDisabled?: boolean,
    groups?: IOption[],
    users?: IOption[],
    isScheduled: boolean,
    selectedImportant: boolean,
    exists?: boolean,
    draftIsMount: boolean,
    messageId: string,
    loader: boolean,
    groupAccess: boolean,
    loading: boolean,
    loadingUsers: boolean,
    scheduledMessageDateTime?: Date,
    scheduledMessageString?: string,
    unstablePinned?: boolean,
    selectedTeamsNum: number,
    selectedRostersNum: number,
    selectedGroupsNum: number,
    usersNum: number,
    selectedRadioBtn: string,
    selectedUpdateType?: string,
    selectedTeams: IOption[],
    selectedRosters: IOption[],
    selectedGroups: IOption[],
    selectedUsers: IOption[],
    usersListFile?: string,
    errorImageUrlMessage: string,
    errorVideoUrlMessage: string,
    buttonUrlsError: boolean,
    forceDisableButton: boolean,
    actions: IAction[],
    topRef: React.RefObject<any>,
    incidentCard?: any,
    incidentSeverity: string,
    areasInvolved: string[],
    networkAffected: string,
    agencyAffected: string,
    serviceImpact: string,
    incidentCardTitle: string,
    latestUpdate: string,
    latestUpdateDate?: Date,
    issueStartTime?: Date,
    isUpdatingScheduledMessage: boolean,
    matchingRosters: IOption[],
    matchingTeams: IOption[],
    templates: ITemplate[],
    selectedTemplate: ITemplate,
    cardElements: string[],
    newsletterHeader?: string,
    isNewsLetterValid: boolean
}

export interface INewMessageProps extends RouteComponentProps, WithTranslation {
    getDraftMessagesList?: any;
    appConfig?: any;
}

class NewMessage extends React.Component<INewMessageProps, formState> {
    readonly localize: TFunction;
    private card: any;
    private incidentCard: any;

    constructor(props: INewMessageProps) {
        super(props);
        this.localize = this.props.t;
        this.card = getInitAdaptiveCard(this.localize);
        this.incidentCard = getInitIncidentAdaptiveCard(this.localize);

        this.state = {
            title: "",
            topRef: React.createRef(),
            summary: "",
            summary2: "",
            draftIsMount: false,
            author: "",
            imageLink: "",
            videoLink: "",
            videoImageLink: "",
            card: this.card,
            page: "UpdateTypeSelection",
            teamsOptionSelected: false,
            rostersOptionSelected: false,
            allUsersOptionSelected: false,
            groupsOptionSelected: false,
            usersOptionSelected: false,
            messageId: "",
            loader: true,
            isScheduled: false,
            selectedImportant: false,
            groupAccess: false,
            loading: true,
            loadingUsers: true,
            emailOptionsSelected: false,
            emailOffsetValue: 60,
            scheduledMessageDateTime: undefined,
            scheduledMessageString: undefined,
            unstablePinned: true,
            selectedTeamsNum: 0,
            selectedRostersNum: 0,
            selectedGroupsNum: 0,
            usersNum: 0,
            selectedRadioBtn: "teams",
            selectedTeams: [],
            selectedRosters: [],
            users: [],
            selectedGroups: [],
            selectedUsers: [],
            usersListFile: undefined,
            errorImageUrlMessage: "",
            errorVideoUrlMessage: "",
            buttonUrlsError: false,
            forceDisableButton: false,
            actions: [],
            incidentSeverity: "",
            areasInvolved: [],
            networkAffected: "",
            agencyAffected: "",
            serviceImpact: "",
            incidentCardTitle: "INITIAL/UPDATE # X /RESOLVED: Severity/Priority | Networks(s) | Location | Issue Description | Ticket #INC0XXXXXX",
            latestUpdate: "",
            incidentCard: this.incidentCard,
            isUpdatingScheduledMessage: false,
            matchingRosters: [],
            matchingTeams: [],
            templates: [],
            selectedTemplate: {} as ITemplate,
            cardElements: ["Image", "Video", "Title", "Summary", "Author", "Actions"],
            isNewsLetterValid: true
        };
    }

    private GetQueryParameters = () => {
        let queryParams: any = {};
        window.location.search.substring(1).split("&").forEach(function (item) {
            let s = item.split("="),
                k = s[0],
                v = s[1] && decodeURIComponent(s[1]);
            queryParams[k] = v;
        });
        return queryParams;
    }

    public async componentDidMount() {
        await app.initialize();

        //- Handle the Esc key
        document.addEventListener("keydown", this.escFunction, false);
        let params = this.props.match && this.props.match.params;
        if (params == undefined) {
            params = {};
        }
        let query = this.GetQueryParameters();
        let scheduledDate = query["date"];
        if (scheduledDate !== undefined) {
            this.setState({
                isScheduled: true,
                scheduledMessageString: moment(scheduledDate).format("YYYY-MM-DDTHH:mm"),
                scheduledMessageDateTime: new Date(scheduledDate)
            });
        }

        await this.setGroupAccess();
        await this.getTemplates();
        this.getTeamList().then(() => {
            if ('id' in params && 'messagetype' in params) {
                const id = String(params['id']);
                let messagetype = params['messagetype'] as string;
                this.getItem(id, messagetype).then(() => {
                    this.setState({
                        exists: true,
                        page: "CardCreation",
                        messageId: id
                    });
                });
                this.getGroupData(id).then(() => {
                    const selectedGroups = this.state.groups ?? [];
                    this.setState({
                        selectedGroups: selectedGroups,
                    });
                });
                this.getUserData(id).then(() => {
                    const selectedUsers = this.state.users ?? [];
                    this.setState({
                        selectedUsers: selectedUsers,
                    });
                });
            } else {
                this.setDefaultCard(this.card);
                this.setState(
                    {
                        exists: false,
                        loader: false,
                    }, () => {
                        let adaptiveCard = new AdaptiveCards.AdaptiveCard();
                        AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (text, result) {
                            result.outputHtml = markDownToHtml(text);
                            result.didProcess = true;
                        };

                        let adaptiveCardContainer = document.getElementsByClassName('adaptiveCardContainer');

                        if (adaptiveCardContainer[0] !== null && adaptiveCardContainer[0] !== undefined) {
                            adaptiveCard.parse(this.state.card);
                            let renderedCard = adaptiveCard.render() as HTMLElement;
                            adaptiveCardContainer[0].appendChild(renderedCard);
                        }
                    }
                );
            }
        });
    }

    componentDidUpdate(prevProps: INewMessageProps, prevState: formState, snapshot: any) {

        if (prevState.titles != this.state.titles
            || prevState.summaries != this.state.summaries
            || prevState.secondarySummaries != this.state.secondarySummaries
            || prevState.imageLinks != this.state.imageLinks
            || prevState.videoLinks != this.state.videoLinks
            || prevState.authors != this.state.authors
            || prevState.selectedTemplate != this.state.selectedTemplate
            || prevState.actionsBlocks != this.state.actionsBlocks) {
            setCard(this.localize, this.card, this.state.cardElements, this.state.selectedTemplate.textColor, this.state, this.state.selectedTemplate)
            this.setState({ card: this.card }, () => {
                this.updateCard();
            })
        }

        this.updateCard();

        if (this.state.page === "AudienceSelection" && prevState.page === "CardCreation") {
            this.state.topRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    public setDefaultCard = (card: any) => {
        setCardStyle(this.localize, card, this.state.selectedTemplate, this.state.cardElements);

    }

    private getTeamList = async () => {
        try {
            const response = await getTeams();
            this.setState({
                teams: response.data.teams,
                matchingTeams: response.data.teams,
                matchingRosters: response.data.teams,
                isAllUserDisabled: response.data.isAllUserDisabled
            });
        } catch (error) {
            return error;
        }
    }

    private setGroupAccess = async () => {
        await verifyGroupAccess().then(() => {
            this.setState({
                groupAccess: true
            });
        }).catch((error) => {
            const errorStatus = error.response.status;
            if (errorStatus === 403) {
                this.setState({
                    groupAccess: false
                });
            }
            else {
                throw error;
            }
        });
    }

    private getGroupData = async (id: string) => {
        try {
            const response = await getGroups(id);
            this.setState({
                groups: response.data
            });
        }
        catch (error) {
            return error;
        }
    }

    private limitButtons = (): boolean => {
        return this.state.actions && this.state.actions.length > 4
    }

    private anyEventExist = () => {
        if (this.state.actions.find(x => x.isEvent) !== undefined) {
            return true;
        } else { return false; }
    }

    private onActionsChange = (token: string, actions: IAction[]) => {
        this.setState((previous) => ({
            actionsBlocks: { ...previous.actionsBlocks, [token]: actions },
        }));
    }

    private onIncidentActionsChange = (actions: IAction[]) => {
        this.setState({ actions }, () => {
            if (this.state.selectedUpdateType === "-999") {
                setActionsIncident(this.incidentCard, this.state.actions)
                this.updateCard();
            }
        });
    }

    private getUserData = async (id: string) => {
        try {
            const response = await getUsers(id);
            this.setState({
                users: response.data
            });
        }
        catch (error) {
            return error;
        }
    }

    private deleteUsersAudience = async () => {
        try {
            if (this.state.usersListFile) {
                await deleteUsersAudience(this.state.usersListFile);
                this.setState({
                    usersListFile: undefined
                });
            }
        }
        catch (error) {
            return error;
        }
    }

    private getItem = async (id: string, messagetype: string) => {
        try {
            let response;
            if (messagetype === "draft") {
                response = await getDraftNotification(id);

            }
            if (messagetype === "scheduled") {
                response = await getSentNotification(id);
                this.setState({ isUpdatingScheduledMessage: true });
            }
            const draftMessageDetail = response.data;
            let selectedRadioButton = "teams";
            if (draftMessageDetail.rosters.length > 0) {
                selectedRadioButton = "rosters";
            } else if (draftMessageDetail.groups.length > 0) {
                selectedRadioButton = "groups";
            } else if (draftMessageDetail.allUsers) {
                selectedRadioButton = "allUsers";
            }

            let actions = draftMessageDetail.actions;
            this.setState({
                teamsOptionSelected: draftMessageDetail.teams.length > 0,
                selectedTeamsNum: draftMessageDetail.teams.length,
                rostersOptionSelected: draftMessageDetail.rosters.length > 0,
                selectedRostersNum: draftMessageDetail.rosters.length,
                usersNum: draftMessageDetail.users.length,
                groupsOptionSelected: draftMessageDetail.groups.length > 0,
                usersOptionSelected: draftMessageDetail.users.length > 0 || draftMessageDetail.usersListFile,
                selectedGroupsNum: draftMessageDetail.groups.length,
                selectedRadioBtn: selectedRadioButton,
                selectedTeams: draftMessageDetail.teams.map((x: string) => this.state.teams?.find(y => y.id === x)),
                selectedRosters: draftMessageDetail.rosters.map((x: string) => this.state.teams?.find(y => y.id === x)),
                selectedGroups: draftMessageDetail.groups,
                selectedUsers: draftMessageDetail.users,
                usersListFile: draftMessageDetail.usersListFile,
                selectedUpdateType: draftMessageDetail.updateType,
                selectedImportant: draftMessageDetail.isImportant,
                actions: actions,
                emailOptionsSelected: draftMessageDetail.sendAsEmail,
                emailOffsetValue: draftMessageDetail.emailOffset,
                titles: draftMessageDetail.titles,
                summaries: draftMessageDetail.summaries,
                secondarySummaries: draftMessageDetail.secondarySummaries,
                imageLinks: draftMessageDetail.imageLinks,
                videoLinks: draftMessageDetail.videoLinks,
                authors: draftMessageDetail.authors,
                actionsBlocks: draftMessageDetail.actionsBlocks
            });

           

            if (messagetype === "scheduled") {
                this.setState({
                    scheduledMessageString: moment(draftMessageDetail.scheduledDate).format("YYYY-MM-DDTHH:mm"),
                    scheduledMessageDateTime: draftMessageDetail.scheduledDate,
                    isScheduled: draftMessageDetail.isScheduled
                });

            }

            let updateType = draftMessageDetail.updateType;
            var card: any;
            if (updateType === "-999") {
                setIncidentCardTitle(this.incidentCard, draftMessageDetail.incidentCardTitle)
                setSeverity(this.incidentCard, draftMessageDetail.incidentSeverity)
                setAreaInvolved(this.incidentCard, draftMessageDetail.areasInvolved)
                setNetworkAffected(this.incidentCard, draftMessageDetail.networkAffected)
                setAgencyAffected(this.incidentCard, draftMessageDetail.agencyAffected)
                setServiceImpact(this.incidentCard, draftMessageDetail.serviceImpact)
                setIssueStartTime(this.incidentCard, moment(new Date(draftMessageDetail.issueStartTime!)).format("MM/DD/YYYY hh:mm A"))
                setActionsIncident(this.incidentCard, actions)
                var setDateOnCard = draftMessageDetail.latestUpdateDate ? moment(new Date(draftMessageDetail.latestUpdateDate!)).format("MM/DD/YYYY hh:mm A") : "";
                if (draftMessageDetail.latestUpdate.length > 0) {
                    setLatestUpdate(this.incidentCard, draftMessageDetail.latestUpdate, setDateOnCard)
                }
                card = this.incidentCard
            } else {
                var dynamicTemplate = this.state.templates.find((t) => t.id === updateType);
                if (dynamicTemplate) {
                    let showDefaultCard = (!draftMessageDetail.title && !draftMessageDetail.imageLink && !draftMessageDetail.videoLink && !draftMessageDetail.summary && !draftMessageDetail.summary2 && !draftMessageDetail.author);
                    this.setState({
                        selectedTemplate: dynamicTemplate,
                        cardElements: dynamicTemplate.elements,
                    });
                }
                card = this.card;
            }

            this.setState(
                {
                    title: draftMessageDetail.title,
                    newsletterHeader: draftMessageDetail.newsletterHeader,
                    summary: draftMessageDetail.summary,
                    summary2: draftMessageDetail.summary2,
                    draftIsMount: true,
                    imageLink: draftMessageDetail.imageLink,
                    videoLink: draftMessageDetail.videoLink,
                    videoImageLink: draftMessageDetail.videoImageLink,
                    author: draftMessageDetail.author,
                    allUsersOptionSelected: draftMessageDetail.allUsers,
                    incidentCardTitle: draftMessageDetail.incidentCardTitle,
                    incidentSeverity: draftMessageDetail.incidentSeverity,
                    areasInvolved: draftMessageDetail.areasInvolved,
                    networkAffected: draftMessageDetail.networkAffected,
                    agencyAffected: draftMessageDetail.agencyAffected,
                    serviceImpact: draftMessageDetail.serviceImpact,
                    latestUpdate: draftMessageDetail.latestUpdate,
                    latestUpdateDate: draftMessageDetail.latestUpdateDate,
                    issueStartTime: draftMessageDetail.issueStartTime,
                    loader: false,
                    card: card,
                }, () => {
                    this.updateCard();
                });
        } catch (error) {
            return error;
        }
    }

    private getTemplates = async () => {
        try {
            let response = await getAllUserTemplates();
            const templatesData = response.data;
            let templatesArray: ITemplate[] = []

            templatesData.forEach((template: any) => {

                var newTemplate: ITemplate = {
                    id: template.id,
                    templateName: template.templateName,
                    indexOrder: template.indexOrder,
                    bannerUrl: template.bannerUrl,
                    backgroundColorUrl: template.backgroundColorUrl,
                    textColor: template.textColor,
                    isEmailEnabled: template.isEmailEnabled,
                    authorGroups: template.authorGroups.length,
                    emailOffSet: template.emailOffSet,
                    allowSendAll: template.allowSendAll,
                    isIncidentSummary: template.isIncidentSummary,
                    isPowerAutomateEnabled: template.isPowerAutomateEnabled,
                    elements: template.elements,
                }
                templatesArray.push(newTemplate)
            })
            const defaultTemplateId = templatesArray && templatesArray.length > 0 && templatesArray[0].id || null;
            if (!!!defaultTemplateId) {
                throw new Error("Templates list is empty");
            }

            this.onTemplateChanged(defaultTemplateId, templatesArray);
            this.setState({
                templates: templatesArray,
            });
        } catch (error) {
            return error;
        }
    }

    public componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    public render(): JSX.Element {
        const downloadIcon = <Attach20Regular />
        if (this.state.loader) {
            return (
                <div className="loader">
                    <Spinner />
                </div>
            );
        } else {
            if (this.state.page === "UpdateTypeSelection") {
                return (
                    <div className="taskModule">
                        <div className="formContainer" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                            <div className="formCentered" style={{ height: "100%" }}>
                                {/*<img style={{ width: "540px", height: "70px" }} src="/Content/company-logo.png" />*/}
                                <h1 style={{ fontWeight: 400 }}>TTALK</h1>
                                <div className='formRadioContainer'>
                                    <h4 style={{ margin: 0, fontWeight: 600, marginBottom: "2rem" }}>Select an option below</h4>
                                    <RadioGroup value={this.state.selectedUpdateType} onChange={(event: any, value: RadioGroupOnChangeData) => this.onTemplateChanged(value.value, this.state.templates)}>
                                        {
                                            this.state.templates.map((t) => {
                                                if (this.state.exists) {
                                                    return t.id !== "-999" ? <Radio name="grouped" value={t.id} label={t.templateName} key={t.id} /> : null
                                                } else {
                                                    return <Radio name="grouped" value={t.id} label={t.templateName} key={t.id} />
                                                }
                                            })
                                        }
                                    </RadioGroup>
                                </div>
                            </div>
                        </div>
                        <div className="footerContainer" >
                            <div className="buttonContainer">
                                <Button id="saveBtn" onClick={(event: any) => { this.onNext(event, "CardCreation"); }} appearance="primary" disabled={!!!this.state.selectedUpdateType} >{this.localize("Next")}</Button>
                            </div>
                        </div>
                    </div>
                )
            }
            else if (this.state.page === "CardCreation" && this.state.selectedUpdateType === "-999") {
                return (
                    <div className="taskModule" id="top" >
                        <div className="formContainer">
                            <div className="formContentContainer">

                                <div className="formContentContainer__input-container">
                                    <Field label="Title" required={!this.state.incidentCardTitle}>
                                        <Input
                                            className="inputField"
                                            value={this.state.incidentCardTitle}
                                            onChange={this.onIncidentTitleChange}
                                            autoComplete="off"
                                            required
                                        />
                                    </Field>

                                </div>

                                <div className="formContentContainer__input-container">
                                    <Field label="Severity / Priority" required={!this.state.incidentSeverity}>
                                        <Dropdown
                                            value={this.state.incidentSeverity}
                                            onOptionSelect={this.onSeverityChange}
                                            className='inputField'>
                                            {this.getSeverityList().map(option => (
                                                <Option key={option} text={option}>
                                                    {option}
                                                </Option>
                                            ))}
                                        </Dropdown>
                                    </Field>
                                </div>

                                <div className="formContentContainer__input-container">
                                    <div className='areaInvolvedInput'>
                                        <Field label="OMC IT Area(s) Involved" required={!this.state.areasInvolved.length}>
                                            <Multiselect
                                                selectedOptions={this.state.areasInvolved}
                                                options={this.getAreasInvolvedList()}
                                                onSelect={this.onAreaInvolvedChange}
                                                onTagClick={this.onAreaInvolvedTagClick}
                                            />
                                        </Field>
                                    </div>
                                </div>

                                <div className="formContentContainer__input-container">
                                    <Field label="OMC Networks and Practice Areas Affected" required={!this.state.networkAffected.length}>
                                        <Dropdown
                                            value={this.state.networkAffected}
                                            onOptionSelect={this.onNetworkAffectedChange}
                                            className='inputField'>
                                            {this.getNetworkAffectedList().map(option => (
                                                <Option key={option} text={option}>
                                                    {option}
                                                </Option>
                                            ))}
                                        </Dropdown>
                                    </Field>
                                </div>

                                <div className="formContentContainer__input-container">
                                    <Field label="Agencies Affected" required={!this.state.agencyAffected}>
                                        <Input
                                            className="inputField"
                                            value={this.state.agencyAffected}
                                            onChange={this.onAgencyAffectedChange}
                                            autoComplete="off"
                                        />
                                    </Field>

                                </div>

                                <div className="formContentContainer__input-container">
                                    <Field label="Issue Start Time (Local)" required={!this.state.issueStartTime}>
                                        <Input
                                            className="inputField"
                                            onChange={this.onIssueStartTimeChange}
                                            defaultValue={moment(new Date(this.state.issueStartTime!)).format("YYYY-MM-DDTHH:mm")}
                                            type="datetime-local"
                                            min={moment().format("YYYY-MM-DDTHH:mm")}
                                            max={moment().add(1, "M").format("YYYY-MM-DDTHH:mm")} />
                                    </Field>
                                </div>

                                <div className="formContentContainer__input-container">
                                    <Field label="Service Impact" required={!this.state.serviceImpact}>
                                        <Textarea
                                            className="inputField"
                                            value={this.state.serviceImpact}
                                            onChange={this.onServiceImpactChange} />
                                    </Field>
                                </div>


                                <div className="formContentContainer__input-container">
                                    <Field label="Updates" required={!this.state.latestUpdate}>
                                        <Textarea
                                            className="inputField"
                                            value={this.state.latestUpdate}
                                            onChange={this.onLatestUpdateChange} />
                                    </Field>
                                </div>


                                <div className="formContentContainer__input-container">
                                    <Field label="Update Date">
                                        <Input
                                            className="inputField"
                                            onChange={this.onUpdateDateChange}
                                            defaultValue={this.state.latestUpdateDate ? moment(new Date(this.state.latestUpdateDate!)).format("YYYY-MM-DDTHH:mm") : ""}
                                            type="datetime-local"
                                            disabled={this.state.latestUpdate ? false : true}
                                            min={moment().add(-1, "M").format("YYYY-MM-DDTHH:mm")}
                                            max={moment().add(1, "M").format("YYYY-MM-DDTHH:mm")} />
                                    </Field>
                                </div>


                                <div className="formContentContainer__attachEvent">
                                    <LinkSet value={this.state.actions} onChange={(actions) => this.onIncidentActionsChange.bind(this)(actions)} />
                                </div>

                                <div className="formContentContainer__attachEvent">
                                    <FileUploader
                                        buttonIcon={downloadIcon}
                                        buttonText={"Attach event details"}
                                        disabled={this.anyEventExist() || this.limitButtons()}
                                        url="/content/uploadEvent"
                                        onSuccess={this.uploadEvent.bind(this)}
                                        acceptedFileTypes=".ics,.ical"
                                    />
                                </div>

                            </div>
                            <div className="adaptiveCardContainer">
                            </div>
                        </div>
                        <div className="footerContainer">
                            <div className="buttonContainer">
                                {!this.state.exists && (
                                    <Button onClick={(event: any) => this.onBack(event, "UpdateTypeSelection")} appearance='secondary' >{this.localize("Back")}</Button>
                                )}
                                <Button disabled={this.isIncidentNextBtnDisabled()} id="saveBtn" onClick={(event: any) => this.onNext(event, "AudienceSelection")} appearance='primary'>{this.localize("Next")}</Button>
                            </div>
                        </div>
                    </div>
                )
            }
            else if (this.state.page === "CardCreation") {
                return (
                    <div className="taskModule" id="top" >
                        <div className="formContainer">
                            <div className="formContentContainer" >
                                {
                                    this.state.cardElements.map((templateToken: string) =>
                                        <>
                                            {templateToken.startsWith("Title") && (
                                                <>
                                                    <div className="formContentContainer__input-container">
                                                        <Field label={this.localize("TitleText")}>
                                                            <Input
                                                                className="inputField"
                                                                value={this.state.titles && this.state.titles[templateToken] || ""}
                                                                onChange={(e, data) => this.onTitleChanged(templateToken, data)}
                                                                autoComplete="off"
                                                                required
                                                            />
                                                        </Field>
                                                    </div>
                                                </>
                                            )}
                                            {templateToken.startsWith("ImageLink") && (
                                                <>
                                                    <div className="formContentContainer__input-container">
                                                        <Field
                                                            label={this.localize("ImageURL")}
                                                            validationMessage={checkUrlError(this.state.imageLinks && this.state.imageLinks[templateToken] || "") ? 'URL must start with https://' : null}
                                                            validationState={checkUrlError(this.state.imageLinks && this.state.imageLinks[templateToken] || "") ? 'error' : 'none'}>
                                                            <div className="formContentContainer__image-source-container">
                                                                <Input
                                                                    className="image-source-container__link-input"
                                                                    value={this.state.imageLinks && this.state.imageLinks[templateToken] || ""}
                                                                    onChange={(_, data) => this.onImageLinkChanged.bind(this)(templateToken, data.value)}
                                                                    autoComplete="off"
                                                                />
                                                                <FileUploader
                                                                    disabled={!!!templateToken.includes("ImageLink")}
                                                                    buttonIcon={downloadIcon}
                                                                    buttonText={"Attach image"}
                                                                    url="/content/uploadImage"
                                                                    onSuccess={(data) => this.onImageLinkChanged.bind(this)(templateToken, data)}
                                                                    acceptedFileTypes=".png,.jpg,.jpeg"
                                                                />
                                                                <Tooltip
                                                                    content="Images must be at most 1024×1024 px, less than 1 MB size, and in PNG, JPEG, or GIF format. Animated GIF is not supported."
                                                                    relationship='label'>
                                                                    <Info24Regular
                                                                        className="succeeded"
                                                                    />
                                                                </Tooltip>
                                                            </div>
                                                        </Field>
                                                        <Text className='errorText'>{this.state.errorImageUrlMessage}</Text>
                                                    </div>
                                                </>
                                            )}
                                            {templateToken.startsWith("VideoLink") && (
                                                <>
                                                    <div className="formContentContainer__input-container">
                                                        <Field label={this.localize("VideoURL")}
                                                            validationMessage={checkUrlError(this.state.videoLinks && this.state.videoLinks[templateToken] && this.state.videoLinks[templateToken].url || "") ? 'URL must start with https://' : null}
                                                            validationState={checkUrlError(this.state.videoLinks && this.state.videoLinks[templateToken] && this.state.videoLinks[templateToken].url || "") ? 'error' : 'none'}>
                                                            <div className="formContentContainer__image-source-container">
                                                                <Input
                                                                    className="image-source-container__link-input"
                                                                    value={this.state.videoLinks && this.state.videoLinks[templateToken] && this.state.videoLinks[templateToken].url || ""}
                                                                    onChange={(_, data) => this.onVideoChanged.bind(this)(templateToken, data.value)}
                                                                    autoComplete="off"
                                                                />

                                                                <FileUploader
                                                                    buttonIcon={downloadIcon}
                                                                    buttonText={"Attach Video"}
                                                                    url="/api/content/uploadVideo"
                                                                    baseServiceUrl={this.props.appConfig?.coreServicesUrl}
                                                                    disabled={!!!this.props.appConfig?.coreServicesUrl || !!!templateToken.startsWith("VideoLink")}
                                                                    onSuccess={(data) => this.onVideoChanged.bind(this)(templateToken, data)}
                                                                    acceptedFileTypes=".mp4,.webm,.ogg"
                                                                />
                                                                <Tooltip
                                                                    content="Video must be YouTube/Vimeo link or Supported upload format: MP4, WebM, OGG"
                                                                    relationship='label'>
                                                                    <Info24Regular
                                                                        className="succeeded"
                                                                    />
                                                                </Tooltip>
                                                            </div>
                                                        </Field>
                                                        <Text className='errorText'>{this.state.errorVideoUrlMessage}</Text>
                                                    </div>
                                                    <div className="formContentContainer__input-container">
                                                        <Field label="Video Image Url"
                                                            validationMessage={checkUrlError(this.state.videoLinks && this.state.videoLinks[templateToken] && this.state.videoLinks[templateToken].previewUrl || "") ? 'URL must start with https://' : null}
                                                            validationState={checkUrlError(this.state.videoLinks && this.state.videoLinks[templateToken] && this.state.videoLinks[templateToken].previewUrl || "") ? 'error' : 'none'}>
                                                            <div className="formContentContainer__image-source-container">
                                                                <Input
                                                                    className="image-source-container__link-input"
                                                                    value={this.state.videoLinks && this.state.videoLinks[templateToken] && this.state.videoLinks[templateToken].previewUrl || ""}
                                                                    onChange={(_, data) => this.onVideoImageLinkChanged.bind(this)(templateToken, data.value)}
                                                                    autoComplete="off"
                                                                    disabled={true}
                                                                />

                                                                <FileUploader
                                                                    buttonIcon={downloadIcon}
                                                                    buttonText={"Attach Video image"}
                                                                    url="/content/uploadVideoImage"
                                                                    onSuccess={(data) => this.onVideoImageLinkChanged.bind(this)(templateToken, data)}
                                                                    acceptedFileTypes=".png,.jpg,.jpeg"
                                                                    disabled={!!!(this.state.videoLinks && this.state.videoLinks[templateToken])} /*TODO*/
                                                                />
                                                                <Tooltip
                                                                    content="Images must be at most 1024×1024 px, less than 1 MB size, and in PNG, JPEG, or GIF format. Animated GIF is not supported."
                                                                    relationship='label'>
                                                                    <Info24Regular
                                                                        className="succeeded"
                                                                    />
                                                                </Tooltip>
                                                            </div>
                                                        </Field>
                                                    </div>
                                                </>
                                            )}
                                            {templateToken.startsWith("Summary") && (
                                                <>
                                                    <div className='formContentContainer__rich-editor-container'>
                                                        <Field label={this.localize("Summary")}
                                                            className='rich-editor-field'
                                                        // validationState={this.state.summaryErrorMessage ? 'error' : 'none'}
                                                        // validationMessage={this.state.summaryErrorMessage}
                                                        >
                                                            <MyEditor onPropertyChanged={(markdown: string) => this.onSummaryChanged(templateToken, markdown)}
                                                                draftIsMount={this.state.draftIsMount}
                                                                initialValue={this.state.summaries && this.state.summaries[templateToken] || ""}
                                                                propertyType="Summary"
                                                            />
                                                        </Field>

                                                    </div>
                                                </>
                                            )}
                                            {templateToken.startsWith("SecondarySummary") && (
                                                <>
                                                    <div className='formContentContainer__rich-editor-container'>
                                                        <Field label={this.localize("Summary") + " 2"}
                                                            className='rich-editor-field'
                                                        // validationState={this.state.summary2ErrorMessage ? 'error' : 'none'}
                                                        // validationMessage={this.state.summary2ErrorMessage}
                                                        >
                                                            <MyEditor onPropertyChanged={(markdown: string) => this.onSummary2Changed(templateToken, markdown)}
                                                                draftIsMount={this.state.draftIsMount}
                                                                initialValue={this.state.secondarySummaries && this.state.secondarySummaries[templateToken] || ""}
                                                                propertyType="Summary"
                                                            />
                                                        </Field>
                                                    </div>
                                                </>
                                            )}
                                            {templateToken.startsWith("Author") && (
                                                <>
                                                    <div className='formContentContainer__rich-editor-container'>
                                                        <Field label={this.localize("Author")}
                                                            className='rich-editor-field'
                                                        // validationState={this.state.authorErrorMessage ? 'error' : 'none'}
                                                        // validationMessage={this.state.authorErrorMessage --- TODO
                                                        >
                                                            <MyEditor onPropertyChanged={(markdown: string) => this.onAuthorChanged(templateToken, markdown)}
                                                                draftIsMount={this.state.draftIsMount}
                                                                initialValue={this.state.authors && this.state.authors[templateToken] || ""}
                                                                propertyType="Author"
                                                            />
                                                        </Field>
                                                    </div>
                                                </>
                                            )}
                                            {templateToken.startsWith("Actions") && (
                                                <>
                                                    <div className="formContentContainer__attachEvent">
                                                        <LinkSet value={this.state.actionsBlocks && this.state.actionsBlocks[templateToken] || []} onChange={(actions: IAction[]) => this.onActionsChange.bind(this)(templateToken, actions)} />
                                                    </div>

                                                    <div className="formContentContainer__attachEvent">
                                                        <FileUploader
                                                            buttonIcon={downloadIcon}
                                                            buttonText={"Attach event details"}
                                                            disabled={this.anyEventExist() || this.limitButtons()}
                                                            url="/content/uploadEvent"
                                                            onSuccess={this.uploadEvent.bind(this)}
                                                            acceptedFileTypes=".ics,.ical"
                                                        />
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )
                                }
                            </div>
                            <div className="adaptiveCardContainer">
                            </div>
                        </div>

                        <div className="footerContainer">
                            <div className="buttonContainer">
                                <Button onClick={(event: any) => this.onBack(event, "UpdateTypeSelection")} appearance='secondary'>{this.state.exists ? "Change Card" : this.localize("Back")}</Button>
                                <Button id="saveBtn" onClick={(event: any) => this.onNext(event, "AudienceSelection")} appearance='primary' disabled={this.isNextBtnDisabled()}>{this.localize("Next")}</Button>
                            </div>
                        </div>
                    </div>
                );
            } else if (this.state.page === "AudienceSelection") {
                return (
                    <div className="taskModule" >
                        <div className="formContainer" >
                            <div className="formContentContainer" ref={this.state.topRef}>
                                <h4>{this.localize("SendHeadingText")}</h4>
                                <RadioGroup
                                    className="radioBtns"
                                    value={this.state.selectedRadioBtn}
                                    onChange={this.onGroupSelected}
                                >
                                    <h3 style={{ fontWeight: 600, margin: "0", }}>{this.localize("SendSelectText")}</h3>

                                    {!this.state.isAllUserDisabled && this.state.selectedTemplate.allowSendAll && (
                                        <>
                                            <Checkbox label={this.localize("SendToAllUsers")}
                                                checked={this.state.allUsersOptionSelected}
                                                onChange={(e, data) => this.setState({ allUsersOptionSelected: !!data.checked })} />
                                            <div className={this.state.allUsersOptionSelected ? "" : "hide"}>
                                                <div className="noteText">
                                                    <Text className='errorText'>{this.localize("SendToAllUsersNote")}</Text>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <CheckBoxWithTooltip
                                        label={this.localize("SendToRostersPlaceHolder")}
                                        checked={this.state.rostersOptionSelected}
                                        onChecked={(c: boolean) => this.setState({ rostersOptionSelected: c })}
                                        tooltip="The application must be installed in the Team to send a communication to the Team’s members."
                                    />

                                    <Multiselect
                                        hidden={!this.state.rostersOptionSelected}
                                        selectedOptions={this.state.selectedRosters}
                                        options={this.state.matchingRosters}
                                        noMatchMessage={this.localize("NoMatchMessage")}
                                        onTagClick={this.onRosterTagClick}
                                        onSearch={this.onRosterSearch}
                                        onSelect={this.onRostersChange}
                                        onClose={this.onRosterSelectBlur}
                                    />

                                    <CheckBoxWithTooltip
                                        label={this.localize("SendToGroups")}
                                        checked={this.state.groupsOptionSelected}
                                        onChecked={(c: boolean) => this.setState({ groupsOptionSelected: c })}
                                        tooltip="M365 Group, Security Group or Distribution List"
                                    />

                                    <Multiselect
                                        hidden={!this.state.groupsOptionSelected || !this.state.groupAccess}
                                        loading={this.state.loading}
                                        loadingMessage={this.localize("LoadingText")}
                                        selectedOptions={this.state.selectedGroups}
                                        options={this.state.groups ?? []}
                                        noMatchMessage={"No matches found."}
                                        onTagClick={this.onGroupTagClick}
                                        onSearch={this.onGroupSearchQueryChange}
                                        onSelect={this.onGroupsChange}
                                        onClose={this.onGroupSelectBlur}
                                    />

                                    <div className={this.state.groupsOptionSelected && !this.state.groupAccess ? "" : "hide"}>
                                        <div className="noteText">
                                            <Text className='errorText'>{this.localize("SendToGroupsPermissionNote")}</Text>
                                        </div>
                                    </div>

                                    <div className={this.state.groupsOptionSelected && this.state.groupAccess ? "" : "hide"}>
                                        <div className="noteText">
                                            <Text className='errorText'>{this.localize("SendToGroupsNote")}</Text>
                                        </div>
                                    </div>

                                    <CheckBoxWithTooltip
                                        label={"Individual user(s)"}
                                        checked={this.state.usersOptionSelected}
                                        onChecked={(c: boolean) => this.setState({ usersOptionSelected: c })}
                                        tooltip="Enter individual usernames in the search box below OR download the Excel template and upload the list of Email addresses you want to send a communication to."
                                    />

                                    <Multiselect
                                        hidden={!this.state.usersOptionSelected || !this.state.groupAccess}
                                        loading={this.state.loadingUsers}
                                        loadingMessage={this.localize("LoadingText")}
                                        selectedOptions={this.state.selectedUsers}
                                        options={this.state.users ?? []}
                                        noMatchMessage="No matches found."
                                        onTagClick={this.onUserTagClick}
                                        onSearch={this.debounceUserSearchQueryChange}
                                        onSelect={this.onUsersChange}
                                        onClose={this.onUserSelectBlur}
                                    />

                                    {this.state.usersOptionSelected && (
                                        <div className="formContentContainer__fileUploadContainer">
                                            <div className="formContentContainer__fileUpload">
                                                <div className="formContentContainer__templateDownload">
                                                    <ExcelIcon aria-label='excel-icon' />
                                                    <Link href="/Content/Audience List.xlsx" inline target='_blank'>Download template</Link>
                                                </div>
                                                <FileUploader
                                                    buttonIcon={downloadIcon}
                                                    buttonText={"Upload users"}
                                                    url="/content/uploadUsersAudience"
                                                    onSuccess={this.uploadUsers.bind(this)}
                                                    acceptedFileTypes=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                />

                                            </div>
                                            {this.state.usersListFile && (
                                                <>
                                                    <Link target="_blank" inline className='formContentContainer__uploadedFile' href={"/api/Content/getUsersAudience?fileName=" + this.state.usersListFile}>{this.state.usersListFile}</Link>
                                                    <Dismiss24Regular style={{ marginLeft: '1rem', cursor: 'pointer', verticalAlign: 'middle' }} onClick={this.deleteUsersAudience} />
                                                </>
                                            )}
                                        </div>
                                    )}

                                    <div>
                                        <CheckBoxWithTooltip
                                            label={"Entire Team/Channel"}
                                            checked={this.state.teamsOptionSelected}
                                            onChecked={(c: boolean) => this.setState({ teamsOptionSelected: c })}
                                            tooltip="The application must be installed in the Team to send a communication into the selected Team’s Channel."
                                        />

                                        <Multiselect
                                            hidden={!this.state.teamsOptionSelected}
                                            selectedOptions={this.state.selectedTeams}
                                            options={this.state.teams ?? []}
                                            noMatchMessage={this.localize("NoMatchMessage")}
                                            onTagClick={this.onTeamTagClick}
                                            onSearch={this.onTeamSearch}
                                            onSelect={this.onTeamsChange}
                                            onClose={this.onTeamSelectBlur}
                                        />
                                    </div>
                                    <div>
                                        <h3 style={{ fontWeight: 600, margin: "4rem 0 5px", }}>Schedule the message</h3>
                                        <div className="inputContainer">

                                            <Field label="Schedule to a later time">
                                                <Input
                                                    onChange={e => this.onScheduledDateChange(e)}
                                                    defaultValue={moment(new Date(this.state.scheduledMessageDateTime!)).format("YYYY-MM-DDTHH:mm")}
                                                    type="datetime-local"
                                                    min={moment().format("YYYY-MM-DDTHH:mm")}
                                                    max={moment().add(1, "M").format("YYYY-MM-DDTHH:mm")} />
                                            </Field>

                                        </div>
                                    </div>

                                    {(this.state.selectedTemplate.isEmailEnabled) && (
                                        <div>
                                            <h3 style={{ fontWeight: 600, margin: "2rem 0 5px", }}>Send as email to unread recipients</h3>
                                            <CheckBoxWithTooltip
                                                label="Enabled"
                                                checked={this.state.emailOptionsSelected}
                                                onChecked={(c: boolean) => this.setState({ emailOptionsSelected: c })}
                                                tooltip="Also send adaptive card as an email to recipients not yet seen the message."
                                            />
                                            <div hidden={!this.state.emailOptionsSelected} >
                                                <div className='inputContainer' style={{ marginLeft: "3.5rem" }}>
                                                    <Field label="Email Delay (minutes)">
                                                        <Input
                                                            type='text'
                                                            required={this.state.emailOptionsSelected}
                                                            value={this.state.emailOffsetValue.toString()}
                                                            onChange={this.onEmailOffsetChange}
                                                            pattern="[0-9]*"
                                                            maxLength={3}
                                                        />
                                                    </Field>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <h3 style={{ fontWeight: 600, margin: "2rem 0 5px", }}>Send as important message</h3>
                                    <CheckBoxWithTooltip
                                        label="Enabled"
                                        checked={this.state.selectedImportant}
                                        onChecked={this.onImportantSelected}
                                        tooltip={this.localize('ImportantDescription')}
                                    />
                                </RadioGroup>

                            </div>

                            <div className="adaptiveCardContainer">
                            </div>

                        </div>

                        <div className="footerContainer">
                            <div className="buttonContainer">
                                <Button onClick={(event: any) => this.onBack(event, "CardCreation")} appearance='secondary' >{this.localize("Back")}</Button>
                                <Button disabled={this.isSaveBtnDisabled() || this.state.forceDisableButton}
                                    id="saveBtn"
                                    onClick={this.state.isUpdatingScheduledMessage && !this.state.scheduledMessageDateTime ? this.onCancelScheduledTask : this.onSave}
                                    appearance='primary' >
                                    {this.state.isScheduled ? "Schedule" : this.localize("SaveAsDraft")}
                                </Button>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (<div>Error</div>);
            }
        }
    }

    private uploadEvent = (response: string): void => {
        let urlsAndEvents = [
            ...this.state.actions,
            { title: "Event details", link: response, isEvent: true },
        ];
        urlsAndEvents = urlsAndEvents.sort((a, b) => (a === b ? 0 : a ? 1 : -1)); //swap -1 and 1 to change order of event and links
        this.setState({ actions: urlsAndEvents }, () => {
            if (this.state.selectedUpdateType === "-999") {
                setActionsIncident(this.incidentCard, this.state.actions)
                this.updateCard();
            } else {
                setActions(this.card, this.state.cardElements, this.state.actions)
                this.updateCard();
            }
        });
    };

    private uploadUsers = (response: string): void => {
        this.setState({ usersListFile: response });
    };

    private onGroupSelected = (value: any) => {
        this.setState({
            selectedRadioBtn: value,
            teamsOptionSelected: value === 'teams',
            rostersOptionSelected: value === 'rosters',
            groupsOptionSelected: value === 'groups',
            allUsersOptionSelected: value === 'allUsers',
            selectedTeams: value === 'teams' ? this.state.selectedTeams : [],
            selectedTeamsNum: value === 'teams' ? this.state.selectedTeamsNum : 0,
            selectedRosters: value === 'rosters' ? this.state.selectedRosters : [],
            selectedRostersNum: value === 'rosters' ? this.state.selectedRostersNum : 0,
            selectedGroups: value === 'groups' ? this.state.selectedGroups : [],
            selectedGroupsNum: value === 'groups' ? this.state.selectedGroupsNum : 0,
            selectedUsers: value === 'users' ? this.state.selectedUsers : [],
            usersNum: value === 'users' ? this.state.usersNum : 0,
        });
    }

    private onImportantSelected = () => {
        this.setState({
            selectedImportant: !this.state.selectedImportant
        });
    }

    private isSaveBtnDisabled = () => {
        const teamsSelectionIsValid = (this.state.teamsOptionSelected && (this.state.selectedTeamsNum !== 0)) || (!this.state.teamsOptionSelected);
        const rostersSelectionIsValid = (this.state.rostersOptionSelected && (this.state.selectedRostersNum !== 0)) || (!this.state.rostersOptionSelected);
        const groupsSelectionIsValid = (this.state.groupsOptionSelected && (this.state.selectedGroupsNum !== 0)) || (!this.state.groupsOptionSelected);
        const usersSelectionIsValid = (this.state.usersOptionSelected && (this.state.usersNum !== 0) || this.state.usersListFile) || (!this.state.usersOptionSelected);
        const nothingSelected = (!this.state.usersOptionSelected) && (!this.state.teamsOptionSelected) && (!this.state.rostersOptionSelected) && (!this.state.groupsOptionSelected) && (!this.state.allUsersOptionSelected);
        const isEmailOption = (this.state.emailOptionsSelected) && (!this.state.emailOffsetValue)
        return (!usersSelectionIsValid || !teamsSelectionIsValid || !rostersSelectionIsValid || !groupsSelectionIsValid || nothingSelected || isEmailOption)
    }

    private isPayloadExceedLimit = (limit: number = 18000): boolean => {
        var actionsTextLength: number = this.state.actionsBlocks && Object.entries(this.state.actionsBlocks).map(([key, value]) => value).flat().reduce<string>((previous, current, index) => {
            return index == 0 ? current.link+current.title : previous + current.link + current.title;
        }, "").length || 0;
        var videoTextLength: number = this.state.videoLinks && Object.entries(this.state.videoLinks).map(([key, value]) => value).flat().reduce<string>((previous, current, index) => {
            const previewUrl = current.previewUrl || "";
            const url = current.url || "";
            return index == 0 ? previewUrl + url : previous + previewUrl + url;
        }, "").length || 0;
        var summariesTextLength = this.state.summaries && Object.entries(this.state.summaries).map(([key, value]) => value).flat().reduce<string>((previous, current, index) => {
            return index == 0 ? current : previous + current;
        }, "").length || 0;
        var secondarySummariesTextLength = this.state.secondarySummaries && Object.entries(this.state.secondarySummaries).map(([key, value]) => value).flat().reduce<string>((previous, current, index) => {
            return index == 0 ? current : previous + current;
        }, "").length || 0;
        var titlesTextLength = this.state.titles && Object.entries(this.state.titles).map(([key, value]) => value).flat().reduce<string>((previous, current, index) => {
            return index == 0 ? current : previous + current;
        }, "").length || 0;
        var authorsTextLength = this.state.authors && Object.entries(this.state.authors).map(([key, value]) => value).flat().reduce<string>((previous, current, index) => {
            return index == 0 ? current : previous + current;
        }, "").length || 0;
        var imagesTextLength = this.state.imageLinks && Object.entries(this.state.imageLinks).map(([key, value]) => value).flat().reduce<string>((previous, current, index) => {
            return index == 0 ? current : previous + current;
        }, "").length || 0;

        const totalPayloadSize = actionsTextLength + videoTextLength + summariesTextLength + secondarySummariesTextLength + titlesTextLength + authorsTextLength + imagesTextLength;

        return totalPayloadSize > limit;
    }

    private isNextBtnDisabled = (): boolean => {

        const actionErrors = !!this.state.actionsBlocks && Object.entries(this.state.actionsBlocks).map(([key, value]) => value).flat().some(x => checkUrlError(x.link))
        const videoErrors = !!this.state.videoLinks && Object.entries(this.state.videoLinks).map(([key, value]) => value).flat().some(x => checkUrlError(x.previewUrl || "") || checkUrlError(x.url || ""))
        const imageErrors = !!this.state.imageLinks && Object.entries(this.state.imageLinks).map(([key, value]) => value).flat().some(x => checkUrlError(x))
        const isLimitExceed = this.isPayloadExceedLimit();
        

        return actionErrors || imageErrors || videoErrors || isLimitExceed;
    }

    private isNextNewsletterBtnDisabled = () => {
        const title = this.state.title;
        const actions = this.state.actions;
        const buttonUrlsError = actions.find(x => checkUrlError(x.link)) !== undefined;

        return !(title && actions.find(x => x.link == "") === undefined && !buttonUrlsError && this.state.isNewsLetterValid);
    }

    private isIncidentNextBtnDisabled = () => {
        const title = this.state.incidentCardTitle;
        const severity = this.state.incidentSeverity;
        const areas = this.state.areasInvolved;
        const network = this.state.networkAffected;
        const agency = this.state.agencyAffected;
        const startTime = this.state.issueStartTime;
        const service = this.state.serviceImpact;
        const update = this.state.latestUpdate;

        return !(title && severity && areas.length > 0 && network && agency && startTime && service && update)
    }

    private getSeverityList = () => {
        return ["Sev1", "Sev2", "Sev3", "P1", "P2"];
    }

    private getAreasInvolvedList = () => {
        return [
            ""
        ]
    }

    private getNetworkAffectedList = () => {
        return ["OMC", "OMG", "DAS", "BBDO", "DDB", "TBWA", "TBD (To Be Determined)", "All Networks (OMC, OMG, DAS, DDBO, DDB, TBWA) were affected"]
    }

    private onSeverityChange = (event: any, itemsData: any) => {
        setSeverity(this.incidentCard, itemsData.optionValue);

        this.setState({
            incidentSeverity: itemsData.optionValue,
            card: this.incidentCard
        }, () => {
            this.updateCard();
        });
    }

    private onAgencyAffectedChange = (event: any) => {
        const agencyAffected = enableMultiSpaces(event.target.value);
        setAgencyAffected(this.incidentCard, agencyAffected)
        this.setState({
            agencyAffected: agencyAffected,
            card: this.incidentCard
        }, () => {
            this.updateCard();
        });
    }

    private onIssueStartTimeChange = (event: any) => {

        setIssueStartTime(this.incidentCard, new Date(event.target.value).toUTCString())

        this.setState({
            issueStartTime: new Date(event.target.value),
            card: this.incidentCard
        }, () => {
            this.updateCard();
        });
    }

    private onServiceImpactChange = (event: any) => {
        const serviceImpact = enableMultiSpaces(event.target.value);
        setServiceImpact(this.incidentCard, serviceImpact)
        this.setState({
            serviceImpact: serviceImpact,
            card: this.incidentCard
        }, () => {
            this.updateCard();
        });
    }

    private onLatestUpdateChange = (event: any) => {
        const update = enableMultiSpaces(event.target.value);
        const dateToUTC = this.state.latestUpdateDate ? new Date(this.state.latestUpdateDate!).toUTCString() : ""
        setLatestUpdate(this.incidentCard, update, dateToUTC)
        this.setState({
            latestUpdate: update,
            card: this.incidentCard
        }, () => {
            this.updateCard();
        });
    }

    private onUpdateDateChange = (event: any) => {

        setLatestUpdate(this.incidentCard, this.state.latestUpdate, new Date(event.target.value).toUTCString())

        this.setState({
            latestUpdateDate: new Date(event.target.value),
            card: this.incidentCard
        }, () => {
            this.updateCard();
        });
    }

    private onAreaInvolvedChange = (selectedOption: any, selectedItemsLength: number) => {

        this.setState(prevState => {
            if (prevState.areasInvolved.length < selectedItemsLength) {
                setAreaInvolved(this.incidentCard, [...prevState.areasInvolved, selectedOption]);
                return {
                    areasInvolved: [...prevState.areasInvolved, selectedOption],
                    card: this.incidentCard
                }
            } else {
                const newAreasInvolved = prevState.areasInvolved.filter(x => x !== selectedOption)
                setAreaInvolved(this.incidentCard, newAreasInvolved);
                return {
                    areasInvolved: newAreasInvolved,
                    card: this.incidentCard
                }
            }

        }, () => {
            this.updateCard();
        });
    }

    private onAreaInvolvedTagClick = (option: string) =>
        this.setState((prevState) => {
            return {
                areasInvolved: prevState.areasInvolved.filter(x => x !== option),
            }
        })


    private onIncidentTitleChange = (event: any) => {
        const title = enableMultiSpaces(event.target.value);
        setIncidentCardTitle(this.incidentCard, title)
        this.setState({
            incidentCardTitle: title,
            card: this.incidentCard
        }, () => {
            this.updateCard();
        });
    }

    private onNetworkAffectedChange = (event: any, itemsData: any) => {

        setNetworkAffected(this.incidentCard, itemsData.optionValue);

        this.setState({
            networkAffected: itemsData.optionValue,
            card: this.incidentCard
        }, () => {
            this.updateCard();
        });
    }

    private onEmailOffsetChange = (event: any) => {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) {
            this.setState({ emailOffsetValue: event.target.value })
        }
    }

    private onScheduledDateChange = (e: any) => {
        if (e.target.value) {
            this.setState({ scheduledMessageDateTime: new Date(e.target.value), isScheduled: true })
        } else {
            this.setState({ scheduledMessageDateTime: undefined, isScheduled: false })
        }
    }

    private static MAX_SELECTED_TEAMS_NUM: number = 20;
    private static MAX_SELECTED_USER_NUM: number = 30;

    private onRosterTagClick = (itemId: string) => {
        this.setState((prevState) => {
            return {
                selectedRosters: prevState.selectedRosters.filter(x => x.id !== itemId),
                selectedRostersNum: prevState.selectedRostersNum - 1
            }
        })
    }

    private onGroupTagClick = (itemId: string) => {
        this.setState((prevState) => {
            return {
                selectedGroups: prevState.selectedGroups.filter(x => x.id !== itemId),
                selectedGroupsNum: prevState.selectedGroupsNum - 1
            }
        })
    }

    private onUserTagClick = (itemId: string) => {
        this.setState((prevState) => {
            return {
                selectedUsers: prevState.selectedUsers.filter(x => x.id !== itemId),
                usersNum: prevState.usersNum - 1
            }
        })
    }

    private onTeamTagClick = (itemId: string) => {
        this.setState((prevState) => {
            return {
                selectedTeams: prevState.selectedTeams.filter(x => x.id !== itemId),
                selectedTeamsNum: prevState.selectedTeamsNum - 1
            }
        })
    }

    private onRostersChange = (selectedItem: IOption, selectedItemsLength: number) => {
        if (selectedItemsLength > NewMessage.MAX_SELECTED_TEAMS_NUM) return;
        this.setState((prevState) => {
            if (prevState.selectedRostersNum < selectedItemsLength) {
                return {
                    selectedRosters: [...prevState.selectedRosters, selectedItem],
                    selectedRostersNum: selectedItemsLength
                }
            } else {
                const newSelectedOptions = prevState.selectedRosters.filter(x => x.id !== selectedItem.id)
                return {
                    selectedRosters: newSelectedOptions,
                    selectedRostersNum: selectedItemsLength
                }
            }
        });
    }


    private onUsersChange = (selectedItem: IOption, selectedItemsLength: number) => {
        if (selectedItemsLength > NewMessage.MAX_SELECTED_USER_NUM) return;
        this.setState((prevState) => {
            if (prevState.usersNum < selectedItemsLength) {
                return {
                    selectedUsers: [...prevState.selectedUsers, selectedItem],
                    usersNum: selectedItemsLength
                }
            } else {
                const newSelectedUsers = prevState.selectedUsers.filter(x => x.id !== selectedItem.id)
                return {
                    selectedUsers: newSelectedUsers,
                    usersNum: selectedItemsLength
                }
            }
        });
    }

    private onGroupsChange = (selectedItem: IOption, selectedItemsLength: number) => {
        this.setState((prevState) => {
            if (prevState.selectedGroupsNum < selectedItemsLength) {
                return {
                    selectedGroups: [...prevState.selectedGroups, selectedItem],
                    selectedGroupsNum: selectedItemsLength
                }
            } else {
                const newSelectedOptions = prevState.selectedGroups.filter(x => x.id !== selectedItem.id)
                return {
                    selectedGroups: newSelectedOptions,
                    selectedGroupsNum: selectedItemsLength
                }
            }
        });
    }

    private onTeamsChange = (selectedItem: IOption, selectedItemsLength: number) => {
        if (selectedItemsLength > NewMessage.MAX_SELECTED_TEAMS_NUM) return;
        this.setState((prevState) => {
            if (prevState.selectedTeamsNum < selectedItemsLength) {
                return {
                    selectedTeams: [...prevState.selectedTeams, selectedItem],
                    selectedTeamsNum: selectedItemsLength
                }
            } else {
                const newSelectedOptions = prevState.selectedTeams.filter(x => x.id !== selectedItem.id)
                return {
                    selectedTeams: newSelectedOptions,
                    selectedTeamsNum: selectedItemsLength
                }
            }
        });
    }

    private onRosterSearch = (searchQuery: string) => {
        const result = this.state.teams?.filter(
            (item => item.name && item.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1)
        );
        this.setState({
            matchingRosters: result ?? []
        })
    };

    private onTeamSearch = (searchQuery: string) => {
        const result = this.state.teams?.filter(
            (item => item.name && item.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1)
        );
        this.setState({
            matchingTeams: result ?? []
        })
    };

    private debounceUserSearchQueryChange = debounce((searchQuery: string) => this.onUserSearchQueryChange(searchQuery), 1000);

    private onUserSearchQueryChange = async (searchQuery: string) => {
        if (!searchQuery) {
            this.setState({
                users: [],
            });
        }
        else if (searchQuery && searchQuery.length <= 2) {
            this.setState({
                loadingUsers: false
            });
        }
        else if (searchQuery && searchQuery.length > 2) {
            this.setState({
                loadingUsers: true
            });

            try {
                const query = encodeURIComponent(searchQuery);
                const response = await searchUsers(query);
                this.setState({
                    users: response.data,
                    loadingUsers: false
                });
            }
            catch (error) {
                return error;
            }
        }
    }

    private onGroupSearchQueryChange = async (searchQuery: string): Promise<void | any> => {
        if (!searchQuery) {
            this.setState({
                groups: []
            });
        }
        else if (searchQuery && searchQuery.length <= 2) {
            this.setState({
                loading: false
            });
        }
        else if (searchQuery && searchQuery.length > 2) {
            this.setState({
                loading: true
            });

            try {
                const query = encodeURIComponent(searchQuery);
                const response = await searchGroups(query);
                this.setState({
                    groups: response.data,
                    loading: false
                });
            }
            catch (error: any) {
                return error;
            }
        }
    }

    private onRosterSelectBlur = () => this.setState({
        matchingRosters: this.state.teams ?? []
    })

    private onGroupSelectBlur = () => this.setState({
        groups: []
    })

    private onUserSelectBlur = () => this.setState({
        users: []
    })

    private onTeamSelectBlur = () => this.setState({
        matchingTeams: this.state.teams ?? []
    })

    private onSave = () => {
        const selectedTeams: string[] = [];
        const selctedRosters: string[] = [];
        const selectedGroups: string[] = [];
        const selectedUsers: string[] = [];
        if (this.state.teamsOptionSelected) this.state.selectedTeams.forEach(x => selectedTeams.push(x.id));
        if (this.state.rostersOptionSelected) this.state.selectedRosters.forEach(x => selctedRosters.push(x.id));
        if (this.state.groupsOptionSelected) this.state.selectedGroups.forEach(x => selectedGroups.push(x.id));
        if (this.state.usersOptionSelected) this.state.selectedUsers.forEach(x => selectedUsers.push(x.id));
        const draftMessage: IDraftMessage = {
            id: this.state.messageId,


            titles: this.state.titles,
            summaries: this.state.summaries,
            secondarySummaries: this.state.secondarySummaries,
            imageLinks: this.state.imageLinks,
            videoLinks: this.state.videoLinks,
            authors: this.state.authors,
            actionsBlocks: this.state.actionsBlocks,

            title: this.state.title,
            imageLink: this.state.imageLink,
            videoLink: this.state.videoLink,
            videoImageLink: this.state.videoImageLink,
            summary: this.state.summary,
            summary2: this.state.summary2,
            author: this.state.author,
            teams: selectedTeams,
            rosters: selctedRosters,
            groups: selectedGroups,
            users: selectedUsers,
            usersListFile: this.state.usersListFile,
            allUsers: this.state.allUsersOptionSelected,
            isScheduled: this.state.isScheduled,
            isImportant: this.state.selectedImportant,
            scheduledDate: this.state.scheduledMessageDateTime,
            updateType: this.state.selectedUpdateType,
            actions: this.state.actions,
            incidentCardTitle: this.state.incidentCardTitle,
            incidentSeverity: this.state.incidentSeverity,
            areasInvolved: this.state.areasInvolved,
            networkAffected: this.state.networkAffected,
            agencyAffected: this.state.agencyAffected,
            serviceImpact: this.state.serviceImpact,
            latestUpdate: this.state.latestUpdate,
            latestUpdateDate: this.state.latestUpdateDate,
            issueStartTime: this.state.issueStartTime,
            sendAsEmail: this.state.emailOptionsSelected,
            emailOffset: this.state.emailOffsetValue.toString(),
            newsletterHeader: this.state.newsletterHeader,
        };

        this.setState({ forceDisableButton: !this.state.forceDisableButton })

        if (this.state.isUpdatingScheduledMessage) {
            this.editScheduledMessage(draftMessage).then(() => {
                dialog.url.submit();
            });
        } else if (this.state.exists) {
            this.editDraftMessage(draftMessage).then(() => {
                dialog.url.submit();
            });
        } else {
            this.postDraftMessage(draftMessage).then(() => {
                dialog.url.submit();
            });
        }
    }

    private editDraftMessage = async (draftMessage: IDraftMessage) => {
        try {
            await updateDraftNotification(draftMessage);
        } catch (error) {
            return error;
        }
    }

    private editScheduledMessage = async (scheduledMessage: IDraftMessage) => {
        try {
            await updateScheduledNotification(scheduledMessage);
        } catch (error) {
            return error;
        }
    }

    private postDraftMessage = async (draftMessage: IDraftMessage) => {
        try {
            await createDraftNotification(draftMessage);
        } catch (error) {
            throw error;
        }
    }

    private onCancelScheduledTask = async () => {
        await cancelScheduledMessage(this.state.messageId).then(() => {
            dialog.url.submit();
        }).catch((error) => {
            throw error;
        });
    }

    public escFunction(event: any) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            dialog.url.submit();
        }
    }

    private onNext = (event: any, page: string) => {
        this.setState({
            page
        }, () => {
            this.updateCard();
        });
    }

    private onBack = (event: any, page: string) => {
        this.setState({
            page
        }, () => {
            this.updateCard();
        });
    }

    private onTemplateChanged = (value: string, templates: ITemplate[]) => {
        var card: any;
        var dynamicTemplate = templates.find((t) => t.id === value);
        if (dynamicTemplate) {
            if (value === "-999") {
                card = this.incidentCard;
                this.setState({
                    selectedUpdateType: value,
                    selectedTemplate: dynamicTemplate,
                    cardElements: [],
                    card: card
                }, () => {
                    this.updateCard();
                });
            } else {
                card = this.card
                let showDefaultCard = (!this.state.title && !this.state.imageLink && !this.state.videoLink && !this.state.summary && !this.state.summary2 && !this.state.author);
                this.setState({
                    selectedUpdateType: value,
                    selectedTemplate: dynamicTemplate,
                    cardElements: dynamicTemplate.elements,
                });
            }

        }
    }

    private onTitleChanged = (token: string, data: InputOnChangeData): void => {
        const title = enableMultiSpaces(data.value);

        this.setState((previous) => ({
            titles: { ...previous.titles, [token]: title },
        }));
    }

    private onImageLinkChanged(token: string, data: string) {
        let url = data;

        this.setState((previous) => ({
            imageLinks: { ...previous.imageLinks, [token]: data },
        }));
    }

    private onVideoImageLinkChanged = (token: string, data: string) => {

        this.setState((previous) => ({
            videoLinks: { ...previous.videoLinks, [token]: { url: previous.videoLinks && previous.videoLinks[token] && previous.videoLinks[token].url || undefined, previewUrl: data } },
        }));
    }

    private onVideoChanged = (token: string, data: string) => {

        this.setState((previous) => ({
            videoLinks: { ...previous.videoLinks, [token]: { url: data, previewUrl: previous.videoLinks && previous.videoLinks[token] && previous.videoLinks[token].previewUrl || undefined } },
        }));
    }



    private onSummaryChanged = (token: string, markdown: string) => {
        const summary = enableMultiSpaces(markdown);
        this.setState((previous) => ({
            summaries: { ...previous.summaries, [token]: summary },
        }));
    }

    private onSummary2Changed = (token: string, markdown: any) => {
        //let showDefaultCard = (!this.state.title && !this.state.imageLink && !this.state.videoLink && !this.state.summary && !markdown && !this.state.author);
        const summary = enableMultiSpaces(markdown);


        this.setState((previous) => ({
            secondarySummaries: { ...previous.secondarySummaries, [token]: summary },
        }));
    }

    private onAuthorChanged = (token: string, markdown: any) => {

        const author = enableMultiSpaces(markdown);
        this.setState((previous) => ({
            authors: { ...previous.authors, [token]: author },
        }));
    }

    private updateCard = () => {
        const adaptiveCard = new AdaptiveCards.AdaptiveCard();
        AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (text, result) {
            result.outputHtml = markDownToHtml(text);
            result.didProcess = true;
        };

        adaptiveCard.parse(this.state.card);
        const renderedCard = adaptiveCard.render() as HTMLElement;
        const adaptiveCardContainer = document.getElementsByClassName('adaptiveCardContainer')[0];

        if (adaptiveCardContainer !== null && adaptiveCardContainer !== undefined) {
            const container = adaptiveCardContainer.firstChild;
            if (container != null) {
                container.replaceWith(renderedCard);
            } else {
                adaptiveCardContainer.appendChild(renderedCard);
            }
        }
    }
}

const mapStateToProps = (state: any) => {
    return { appConfig: state?.appConfig };
}

const newMessageWithTranslation = withTranslation()(NewMessage);
export default connect(mapStateToProps)(newMessageWithTranslation);
